import React from "react";

const SearchIcon = ({
  className = "",
  fill = "none",
  height = 30,
  width = 30,
  stroke = "#556C84",
  strokeWidth = 1
}: SearchIconProps) => (
  <svg width={width} height={height} viewBox="0 0 18 18" className={className}>
    <path
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      d="M17.33 17.722a.276.276 0 01.392-.391l-3.707-3.707a.276.276 0 11-.391.39l3.707 3.708zm-9.813-3.438a6.767 6.767 0 100-13.534 6.767 6.767 0 000 13.534zm0 .553a7.32 7.32 0 110-14.64 7.32 7.32 0 010 14.64zM7.11 2.972a.276.276 0 01.036-.55 4.725 4.725 0 00-4.724 4.724.276.276 0 01.552 0c0-2.3 1.862-4.165 4.16-4.172z"
    />
  </svg>
);

export default SearchIcon;

interface SearchIconProps {
  className?: string;
  fill?: string;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
  width?: number;
}
